<template>
  <g class="fluid-rates">
    <text class="title" :x="100" :y="0" data-cy="title-surface-rate"
      >Surface Rate ({{
        targetLiquidFlowUnit?.shortLabel ??
        LiquidFlowRateUnits.BarrelsPerDay.shortLabel
      }})</text
    >
    <text class="totalLiquidRate" :x="100" :y="28" data-cy="total-liquid-rate">
      {{
        format(
          convert(
            scenarioCalculations.surfaceFlowRates.value.liquidFlowRateSTBD,
            LiquidFlowRateUnits.BarrelsPerDay,
            targetLiquidFlowUnit
          )
        )
      }}
    </text>

    <g class="bar" transform="translate(0 40)">
      <text class="oilRate" data-cy="oil-rate">
        {{
          format(
            convert(
              scenarioCalculations.surfaceFlowRates.value.oilFlowRateSTBD,
              LiquidFlowRateUnits.BarrelsPerDay,
              targetLiquidFlowUnit
            )
          )
        }}
      </text>
      <text :x="200" class="waterRate" data-cy="water-rate">
        {{
          format(
            convert(
              scenarioCalculations.surfaceFlowRates.value.waterFlowRateSTBD,
              LiquidFlowRateUnits.BarrelsPerDay,
              targetLiquidFlowUnit
            )
          )
        }}
      </text>
      <rect y="8" height="16" width="200" ry="6" data-cy="bar-rect" />
      <text class="label" :y="36" data-cy="label-oil">OIL</text>
      <text class="label water" :x="200" :y="36" data-cy="label-water"
        >WATER</text
      >
    </g>
  </g>
</template>

<script setup lang="ts">
import type { Scenario } from "@/composables/forms/formTypes";
import type { ScenarioCalculations } from "@/composables/scenarioCalculations/calculationTypes";
import { convert } from "@/libs/units";
import { LiquidFlowRateUnits } from "@/libs/units/flowRate";
import { toRefs } from "vue";
import { useScenarioUnits } from "@/composables/units/useScenarioUnits";
import { useSettingsStore } from "@/store";
import { sizingKey } from "@/composables/scenarioDetailProvider/scenarioDetailProviderKeys";
import { injectStrict } from "@/utils/utils";

const props = defineProps<{
  scenario: Scenario;
  scenarioCalculations: ScenarioCalculations;
  sagdMode?: boolean;
}>();
const { userSettingsNumberFormat } = useSettingsStore();

const format = Intl.NumberFormat(userSettingsNumberFormat.value, {
  maximumFractionDigits: 2
}).format;

const { scenario } = toRefs(props);

const sizing = injectStrict(sizingKey, null);
const { getLiquidFlowUnit } = useScenarioUnits(scenario, sizing);
const targetLiquidFlowUnit = getLiquidFlowUnit(
  "Target Liquid Rate.convert.STB/D"
);
</script>
